<template>
  <div class="root-hot">
    <div class="hot-box">
      <div v-for="(item, index) in showList" :key="index" class="row">
        <div class="img-wrapper">
          <img class="map-img" id="map_img" :src="item.map" :alt="item.mac" />
          <img class="hot-img" id="hot_img" :src="item.hotmap" :alt="item.mac" />
          <!-- <canvas class="hot-canvas" id="my_canvas">{{ item.mac }}</canvas> -->
        </div>
        <div class="row-info" :style="setStyle(useScene, 'TEXT')">
          <div class="row-font">{{ item.deviceName }}</div>
          <Tooltip :content="item.depName">
            <div class="row-font">{{ item.depName.slice(0, 10) }}</div>
          </Tooltip>
        </div>
      </div>
    </div>
    <Page
      :total="totalDevice"
      size="small"
      @on-change="changeClick"
      class="page"
      :page-size="3"
      :style="setStyle(useScene, 'PAGE')"
    />
    <Spin size="large" v-if="isLoading" fix></Spin>
  </div>
</template>

<script>
import api from '../api/home/index';
import cache from '../common/js/cache';
const AJAX = ['getHotCoord', 'getHotPic', 'getHotListDevice'];
const { st, et, gauss, minTime } = cache.today_time();
const DEFAULT = {
  CACHE: {
    PIC: 'pic_for_mac',
    COORD: 'coord_for_pic',
    DEVICE: 'device_list',
  },
  RATE: {
    W: 180 / 320,
    H: 135 / 240,
  },
};
export default {
  data() {
    return {
      showList: [],
      swiperValue: 0,
      isLoading: true,
      totalDevice: 0,
      deviceList: null,
      index: 1,
    };
  },
  props: {
    useScene: {},
  },
  mounted() {
    window.cache = cache;
    this.initData();
  },
  methods: {
    /**
     * @description set style
     * @author lt
     * @param {*String} s scene
     * @param {*String} t type
     */
    setStyle(s, t) {
      const style_map = {
        FULL_PAGE: 'line-height:70px;',
        NORMAL_PAGE: 'line-height:100px',
        FULL_TEXT: 'color:#7f7f7f',
        NORMAL_TEXT: 'color:#313131',
      };
      return style_map[`${s}_${t}`];
    },
    /**
     * @author lt
     * @description draw hot
     */
    // draw() {
    //   requestAnimationFrame(() => {
    //     (() => {
    //       const canvases = document.querySelectorAll('.hot-canvas');
    //       canvases.forEach((canvas, i) => {
    //         const { coord } = this.showList[i];
    //         this.setCanvas(canvas, coord);
    //       });
    //     })();
    //   });
    // },
    /**
     * @description using point to draw canvas
     * @author lt
     * @param {Element} c canvas ele
     * @param {Array} p point list
     */
    // setCanvas(c, p) {
    //   if (!(c instanceof HTMLCanvasElement)) return;
    //   if (p.length < 1) return;
    //   const pp = p.map(i => JSON.parse(i.points));
    //   const ctx = c.getContext('2d');

    //   ctx.width = 180;
    //   ctx.clearRect(0, 0, 180, 135);

    //   ctx.beginPath();
    //   ctx.moveTo(pp[0][0][0] * DEFAULT.RATE.W, pp[0][0][0] * DEFAULT.RATE.H);

    //   pp.forEach(point => {
    //     point.map(r => {
    //       ctx.lineTo(r[0] * DEFAULT.RATE.W, r[1] * DEFAULT.RATE.H);
    //     });
    //   });

    //   ctx.closePath();
    //   ctx.globalAlpha = 0.4;
    //   ctx.fillStyle = 'white';
    //   ctx.fill();

    //   ctx.strokeStyle = 'red';
    //   ctx.lineWidth = 1;
    //   ctx.stroke();
    // },
    /**
     * @author lt
     * @param {Number} e page index
     */
    async changeClick(e) {
      this.index = e;
      await this.handleSlice(this.deviceList.slice(this.index * 3 - 3, this.index * 3));
    },
    /**
     * @description handle base params
     * @author lt
     * @param {String} mac
     */
    baseParams(mac) {
      return {
        mac,
        startTime: st,
        endTime: et,
        gauss: gauss,
      };
    },
    /**
     * @author lt
     * @description cache ajax
     * @param {String} t  unique cache string
     * @param {Number} f index
     * @param {String} mac mac
     */
    async handleCache(t, f, mac) {
      const cache_result = cache.get(t);
      const is_cached = cache.has(t);
      if (is_cached) {
        if (cache_result !== 'OVER') {
          return cache_result;
        }
      } else {
        const p_c = (({ startTime, endTime, mac }) => ({ startTime, endTime, mac, minTime }))(this.baseParams(mac));
        const pa_map = {
          0: p_c,
          1: this.baseParams(mac),
          2: {},
        };
        const r = await this.launchAjax(AJAX[f], pa_map[f]);
        cache.set(t, r);
        return r;
      }
    },
    /**
     * @author lt
     * @description handle array by request two ajax functions
     * @param {Array} arr need handle array
     */
    async handleSlice(arr) {
      this.isLoading = true;
      this.showList = [];
      let af = [];
      for (let i = 0; i < arr.length; i++) {
        let { mac, depName, deviceName } = arr[i];
        const pic_map = await this.handleCache(`${DEFAULT.CACHE.PIC}_${i}_${mac}`, 1, mac);
        const coord = await this.handleCache(`${DEFAULT.CACHE.COORD}_${i}_${mac}`, 0, mac);
        af.push({ deviceName, depName, mac, map: pic_map.map, hotmap: pic_map.hotmap, coord });
      }
      this.showList = af;
      // this.draw();
      this.isLoading = false;
    },
    /**
     * @author lt
     * @description init
     */
    async initData() {
      const r = await this.handleCache(DEFAULT.CACHE.DEVICE, 2);
      if (!r) return;
      this.deviceList = r;
      this.totalDevice = this.deviceList.length;
      await this.handleSlice(this.deviceList.slice(this.index * 3 - 3, this.index * 3));
    },
    /**
     *
     * @param {String} f api
     * @param {Object} p request params
     */
    async launchAjax(f, p) {
      try {
        return await api[f](p);
      } catch (e) {
        console.error(`[🤢🤢🤢🤢]-[${f}]-${e}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.root-hot {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .hot-box {
    display: flex;
    gap: 10px;
    // justify-content: space-between;
    .row {
      display: flex;
      flex-direction: column;

      .img-wrapper {
        display: flex;
        width: 100%;
        height: 100%;
        position: relative;
        .map-img {
          width: 100%;
          height: 135px;
          border-radius: 8px;
        }
        .hot-img {
          position: absolute;
          z-index: 100;
          left: 0;
          top: 0;
          height: 135px;
          width: 100%;
        }
        .hot-canvas {
          position: absolute;
          left: 0;
          top: 0;
          height: 135px;
          width: 100%;
        }
      }
    }
    .row-info {
      padding-top: 30px;
      .row-font {
        font-weight: 400;
        font-size: 13px;
        color: inherit;
      }
    }
  }
  .page {
    position: relative;
    margin: 0 auto;
    ::v-deep {
      .ivu-progress-outer {
        margin-top: 4px;
      }
      .ivu-page-prev {
        background: rgba(255, 255, 255, 0.1) !important;
      }
      .ivu-page-next {
        background: rgba(255, 255, 255, 0.1) !important;
      }
      .ivu-page-item {
        background: rgba(255, 255, 255, 0.1) !important;
      }
    }
  }
}
</style>
